import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-91ed5376"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-left"
}, [/*#__PURE__*/_createElementVNode("span", null, "会员充值中心")], -1));
const _hoisted_4 = {
  class: "header-right"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "安全支付保障", -1));
const _hoisted_6 = {
  class: "member-card-wrapper"
};
const _hoisted_7 = {
  class: "card-header"
};
const _hoisted_8 = {
  class: "card-title"
};
const _hoisted_9 = {
  class: "card-tag"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会员特权", -1));
const _hoisted_11 = {
  class: "price-section"
};
const _hoisted_12 = {
  class: "price-amount"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "currency"
}, "￥", -1));
const _hoisted_14 = {
  class: "amount"
};
const _hoisted_15 = {
  class: "price-period"
};
const _hoisted_16 = {
  class: "benefits-list"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "placeholder-content"
}, null, -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  class: "card-footer"
};
import { onMounted, ref } from "vue";
import { XiaoniuFrontedControllerService } from "../../generated/services/XiaoniuFrontedControllerService";
import { useLoginUserStore } from "@/store/loginUser";
import { AlipayOutlined, CrownOutlined, GiftOutlined, ClockCircleOutlined, SafetyCertificateOutlined, CheckCircleFilled, CloseCircleFilled, WechatOutlined } from '@ant-design/icons-vue';
import { message } from "ant-design-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MemberView',
  setup(__props) {
    const loginUserStore = useLoginUserStore();
    const loadingMap = ref(new Map()); // 使用Map存储每个会员卡片的loading状态
    const memberInfoList = ref([]);
    const maxBenefitsCount = ref(0); // 记录最多的特权数量，用于计算占位符
    // 获取会员卡片样式类
    const getMemberClass = item => {
      if (item.name === '黄金会员') return 'gold';
      if (item.name === '钻石会员') return 'diamond';
      if (item.name === '专业会员') return 'pro';
      if (item.name === '至尊会员') return 'supreme';
      return '';
    };
    // 获取会员的包含特权
    const getShoppingBenefits = memberItem => {
      if (!memberItem.shoppingName) return [];
      return memberItem.shoppingName.split(';').filter(item => item.trim() !== '');
    };
    // 获取会员的不包含特权
    const getNotShoppingBenefits = memberItem => {
      if (!memberItem.notShoppingName) return [];
      return memberItem.notShoppingName.split(';').filter(item => item.trim() !== '');
    };
    // 计算需要的占位符数量，以保持卡片高度一致
    const getPlaceholderCount = memberItem => {
      const currentBenefitsCount = getShoppingBenefits(memberItem).length + getNotShoppingBenefits(memberItem).length;
      return Math.max(0, maxBenefitsCount.value - currentBenefitsCount);
    };
    const getMemberInfo = async () => {
      const res = await XiaoniuFrontedControllerService.listUsingGet14();
      memberInfoList.value = res.data;
      // 计算最大特权数量（包括钻石会员）
      if (memberInfoList.value.length > 0) {
        const allMembers = [...memberInfoList.value];
        allMembers.forEach(item => {
          const shoppingCount = getShoppingBenefits(item).length;
          const notShoppingCount = getNotShoppingBenefits(item).length;
          const totalCount = shoppingCount + notShoppingCount;
          maxBenefitsCount.value = Math.max(maxBenefitsCount.value, totalCount);
        });
      }
    };
    onMounted(() => {
      //获取会员信息
      getMemberInfo();
    });
    //会员下单 并且跳转支付界面
    const payMember = async item => {
      //验证用户是否登录
      if (!loginUserStore.isLogin) {
        message.error('您尚未登录~');
        return;
      }
      loadingMap.value.set(item.id, true); // 设置当前会员卡片的loading状态
      //下单
      //创建订单对象
      const XiaoniuMemberOrder = {
        price: item.price,
        type: item.type,
        period: item.period
      };
      const orderRes = await XiaoniuFrontedControllerService.addMemberOrderUsingPost(XiaoniuMemberOrder);
      if (orderRes.code == 200) {
        //调用支付接口
        const payRes = await XiaoniuFrontedControllerService.payMemberUsingPost(orderRes.data);
        //跳转到支付页面
        window.location = payRes.paymentUrl;
      } else {
        message.error(orderRes.msg);
        loadingMap.value.set(item.id, false); // 重置当前会员卡片的loading状态
      }
    };
    // 检查特定会员卡片是否处于loading状态
    const isLoading = item => {
      return !!loadingMap.value.get(item.id);
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_card = _resolveComponent("a-card");
      const _component_a_list_item = _resolveComponent("a-list-item");
      const _component_a_list = _resolveComponent("a-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_unref(SafetyCertificateOutlined), {
        class: "secure-icon"
      }), _hoisted_5])]), _createVNode(_component_a_list, {
        grid: {
          gutter: 24,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 2,
          xl: 3,
          xxl: 3
        },
        "data-source": memberInfoList.value.length > 0 ? [...memberInfoList.value] : [],
        class: "member-list"
      }, {
        renderItem: _withCtx(({
          item
        }) => [_createVNode(_component_a_list_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_a_card, {
            hoverable: "",
            class: _normalizeClass(['member-card', getMemberClass(item)])
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_unref(CrownOutlined), {
              class: _normalizeClass(["crown-icon", {
                'gold-icon': item.name === '黄金会员',
                'diamond-icon': item.name === '钻石会员',
                'pro-icon': item.name === '专业会员',
                'supreme-icon': item.name === '至尊会员'
              }])
            }, null, 8, ["class"]), _createElementVNode("span", null, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(GiftOutlined)), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(item.price), 1)]), _createElementVNode("div", _hoisted_15, [_createVNode(_unref(ClockCircleOutlined)), _createElementVNode("span", null, _toDisplayString(item.periodName), 1)])]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getShoppingBenefits(item), (benefit, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "benefit-item",
                key: 'benefit-' + index
              }, [_createVNode(_unref(CheckCircleFilled), {
                class: "benefit-icon included"
              }), _createElementVNode("span", null, _toDisplayString(benefit), 1)]);
            }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNotShoppingBenefits(item), (benefit, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "benefit-item",
                key: 'not-benefit-' + index
              }, [_createVNode(_unref(CloseCircleFilled), {
                class: "benefit-icon excluded"
              }), _createElementVNode("span", null, _toDisplayString(benefit), 1)]);
            }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPlaceholderCount(item), i => {
              return _openBlock(), _createElementBlock("div", {
                class: "benefit-item placeholder",
                key: 'placeholder-' + i
              }, _hoisted_18);
            }), 128))]), _createElementVNode("div", _hoisted_19, [item.name !== '专业会员' ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              size: "large",
              loading: isLoading(item),
              onClick: $event => payMember(item),
              class: "pay-button"
            }, {
              icon: _withCtx(() => [_createVNode(_unref(AlipayOutlined))]),
              default: _withCtx(() => [_createTextVNode(" 立即开通 ")]),
              _: 2
            }, 1032, ["loading", "onClick"])) : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              size: "large",
              class: "pay-button contact-button"
            }, {
              icon: _withCtx(() => [_createVNode(_unref(WechatOutlined))]),
              default: _withCtx(() => [_createTextVNode(" 联系+v xiaoniuzui6 ")]),
              _: 1
            }))])]),
            _: 2
          }, 1032, ["class"])])]),
          _: 2
        }, 1024)]),
        _: 1
      }, 8, ["data-source"])]);
    };
  }
});